
<div class="content" role="main">


<app-image-list></app-image-list>
  
</div>

<router-outlet></router-outlet>

<div  onclick="location.href='https://learn.inotap.online';" style="
    bottom: 0;
    left: 0;
    width: 153px;
    height: 43px;
    position: fixed;
    background-image: url(https://learn.inotap.online/wp-content/uploads/2021/02/LEARN2-1-300x103-1.png);
    background-size: 100% 100%;
    background-color: transparent;
    border: 0;
    " 
class="footer">